import { hasAuth } from "@/router/utils";
import { watchEffect, type WatchStopHandle } from "vue";
import type { Directive } from "vue";

type AuthValue = string | Array<string>;
type AuthState = {
  value: AuthValue;
  display: string;
  stop: WatchStopHandle;
};

const authStates = new WeakMap<HTMLElement, AuthState>();

function validateAuth(value: AuthValue) {
  if (!value) {
    throw new Error(
      "[Directive: auth]: need auths! Like v-auth=\"['btn.add','btn.edit']\""
    );
  }
}

export const auth: Directive<HTMLElement, AuthValue> = {
  mounted(el, binding) {
    validateAuth(binding.value);
    const state: AuthState = {
      value: binding.value,
      display: el.style.display,
      stop: () => {}
    };
    state.stop = watchEffect(() => {
      el.style.display = hasAuth(state.value) ? state.display : "none";
    });
    authStates.set(el, state);
  },
  updated(el, binding) {
    validateAuth(binding.value);
    const state = authStates.get(el);
    if (state && state.value !== binding.value) {
      state.value = binding.value;
      el.style.display = hasAuth(state.value) ? state.display : "none";
    }
  },
  unmounted(el) {
    authStates.get(el)?.stop();
    authStates.delete(el);
  }
};
